
export const stateOptions = [
  { value: "Jammu And Kashmir", label: "Jammu And Kashmir", code: '01' },
  { value: "Himachal Pradesh", label: "Himachal Pradesh", code: '02' },
  { value: "Punjab", label: "Punjab", code: '03' },
  { value: "Chandigarh", label: "Chandigarh", code: '04' },
  { value: "Uttarakhand", label: "Uttarakhand", code: '05' },
  { value: "Haryana", label: "Haryana", code: '06' },
  { value: "Delhi", label: "Delhi", code: '07' },
  { value: "Rajasthan", label: "Rajasthan", code: '08' },
  { value: "Uttar Pradesh", label: "Uttar Pradesh", code: '09' },
  { value: "Bihar", label: "Bihar", code: '10' },
  { value: "Sikkim", label: "Sikkim", code: '11' },
  { value: "Arunachal Pradesh", label: "Arunachal Pradesh", code: '12' },
  { value: "Nagaland", label: "Nagaland", code: '13' },
  { value: "Manipur", label: "Manipur", code: '14' },
  { value: "Mizoram", label: "Mizoram", code: '15' },
  { value: "Tripura", label: "Tripura", code: '16' },
  { value: "Meghalaya", label: "Meghalaya", code: '17' },
  { value: "Assam", label: "Assam", code: '18' },
  { value: "West Bengal", label: "West Bengal", code: '19' },
  { value: "Jharkhand", label: "Jharkhand", code: '20' },
  { value: "Odisha", label: "Odisha", code: '21' },
  { value: "Chhattisgarh", label: "Chhattisgarh", code: '22' },
  { value: "Madhya Pradesh", label: "Madhya Pradesh", code: '23' },
  { value: "Gujarat", label: "Gujarat", code: '24' },
  { value: "Dadra And Nagar Haveli And Daman And Diu", label: "Dadra And Nagar Haveli And Daman And Diu", code: '26' },
  { value: "Maharashtra", label: "Maharashtra", code: '27' },
  { value: "Karnataka", label: "Karnataka", code: '29' },
  { value: "Goa", label: "Goa", code: '30' },
  { value: "Lakshadweep", label: "Lakshadweep", code: '31' },
  { value: "Kerala", label: "Kerala", code: '32' },
  { value: "Tamil Nadu", label: "Tamil Nadu", code: '33' },
  { value: "Puducherry", label: "Puducherry", code: '34' },
  { value: "Andaman And Nicobar", label: "Andaman And Nicobar", code: '35' },
  { value: "Telangana", label: "Telangana", code: '36' },
  { value: "Andhra Pradesh", label: "Andhra Pradesh", code: '37' },
  { value: "Ladakh", label: "Ladakh", code: '38' },
  { value: "Other Countries", label: "Other Countries", code: '96' },
  { value: "Other Territory", label: "Other Territory", code: '97' },
  { value: "Centre Jurisdiction", label: "Centre Jurisdiction", code: '99' }
];


  export const centerOptions = [
    { value: "MAJOR CENTER", label: "MAJOR CENTER"},
    { value: "CENTER", label: "CENTER"},
    { value: "SUB CENTER", label: "SUB CENTER"},
    { value: "POINT", label: "POINT"},
    { value: "UNKNOWN", label: "UNKNOWN"}
  ];

  export const booleanOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' }
];



 export const ModeOfTransportOptions = [
   { value: "By Satsang Vehicle", label:  "By Satsang Vehicle" },
   { value: "By Road", label:  "By Road" },
   { value: "By Goods Transportation Agency", label:  "By Goods Transportation Agency" },
   { value: "By Hand", label:  "By Hand" },
   { value: "By Train", label: "By Train" },
   { value: "Vehicle Itself", label:  "Vehicle Itself" },
  ];

  export const tyreOptions = [
    { value: 2, label: '2 Axles' },
    { value: 3, label: '3 Axles' },
    { value: 4, label: '4 Axles' },
    { value: 5, label: '5 Axles' },
    { value: 6, label: '6 Axles' },
    { value: 7, label: '7 Axles' },
  ];
  export const vehicleOptions = [
    { value: 'Pick Up', label: 'Pick Up' },
    { value: 'Truck', label: 'Truck' },
    { value: 'Tractor', label: 'Tractor' },
    { value: '2 Wheelers', label: '2 Wheelers' },
    { value: '4 Wheelers', label: '4 Wheelers' },
    { value: 'Other', label: 'Other' },
  ];

  export const docTypeOptions = [
    { value: "physical", label: "भौतिक" },
    { value: "digital", label: "इलेक्ट्रॉनिक / व्हाट्सएप ग्रुप" }
  ];

export const receivedDocsOptions = [
  { value: "yes", label: "हाँ" },
  { value: "no", label: "ना" }
];

export const permissionColumnGroups = {
  Masters: {
    label: 'Masters',
    items: {
      department: 'Department',
      stores: 'Stores & Areas',
      sewadar: 'Sewadars',
      ledgerGroup:'Ledger Group',
      ledgerMaster:'Ledger Master',
      purposeLedger:"Ledger - Purpose",
      itemGroup:'Inventory Group',
      itemMaster:'Inventory Master',
      itemEvent:'Inventory - Event',
      uom:'UOM',
      mmsMaping:'MMS Maping',
      vehicleMaster:'Vehicle Master',
      operator: 'Operator',
      recipe: 'Recipe',
    },  
  },
  Inward: {
    label: 'Inward',
    items: {
      receiptVoucher: 'Receipt Voucher',
      additions: 'Additions'
    },
  },
  Outward: {
    label: 'Outward',
    items: {
      deliveryChallan: 'Delivery Challan',
      deductions: 'Deductions',
      gatePass: 'Gate Pass',
      recipeConsumption: 'Recipe Consumption',
    },
  },
  'Department Functions': {
    label: 'Department Functions',
    items: {
      openingStock: 'Opening Stock',
      locationTransfer: 'Location Transfer',
      statusTransfer: 'Status Transfer',
      itemConversion:'Conversion',
      unUsableProduction:"Unuseable Production",
      transactionEntry:"Event Transactions",
      canteenSale:"Canteen Sale"
    },
  },
  'Inter Deptt. Transfers': { 
    label: 'Inter Deptt. Transfers',
    items: {
      issueRequest: 'Issue Request',
      issueSlip: 'Issue Slip',
      returnSlip: 'Return Slip',
      returnAcceptance:'Return Acceptance'
    },
  },
  'Security Functions': {
    label: 'Security Functions',
    items: {
      securityIn: 'Security In',
      securityOut: 'Security Out',
      BillDetails: 'Bill Details',
      PendingSIReport: 'Pending SI Report',
    },
  },
  Adminstration: {
    label: 'Adminstration',
    items: {
      areaProjects: 'Area Projects',
      mrInfo: 'Material Requisition',
      // tam:'Transaction Account Management',
      // voucherStatusHandler:'Voucher Status Handler',
      projectRequirement:'Project Requirement',
      requirementAssessment:'Requirement Assessment',
      receiptAllocation:'Receipt Allocation',
      ConfirmationLetter:'Confirmation Letter',
      DonationLetter:'Donation Letter',
      ProjectReport:'Project Item Report',
      LedgerProjectReport:'Ledger Project Report',
      RentedItemRequirement:'Rented Item Requirement'
    },
  },
  "Accounts Management": {
    label: 'Accounts Management',
    items: {
      accountsManagement: 'Accounts Management',
    },
  },
  'Ledger Functions': {
    label: 'Ledger Functions',
    items: {
      OpeningStockLedger: 'Opening Stock',
      additionLedger: 'Additions',
      deductionLedger: 'Deductions',
      LedgerInventoryReport:"Ledger Inventory Report"
    },
  },
  Reports: {
    label: 'Reports',
    items: {
      departmentInventory: 'Overall Department Inventory',
      itemAnalysis: 'Overall Item Analysis',
      departmentItemAnalysis: 'Department Item Analysis',
      fuelReport: 'Fuel Ledger',
      fuelConsumptionReport: 'Fuel Consumption',
      statusWiseReport: 'Status Wise Report',
      eventWiseReports: 'Event Wise Reports',
      globalItemTransaction: 'Item Ledger',
      depttInventoryTransaction: 'Deptt Inventory Transaction',
      openingStockReport: 'Department Opening Stock',
      departmentItemList: 'Department Item List',
      itemGroupList: 'Item Group List',
      LedgerVoucherReport:'Ledger Voucher Report',
      PendingConsumablesLedger:'Pending Consumables - Ledger',
      DepartmentIssueReport:'Department Issue Report',
      pendingReturnableChallan:'Pending Returnables - Delivery Challan',
      pendingReturnableReceipt:'Pending Returnables - Receipt Voucher',
    },

  },
};
export const returnableOptions = [
  { label: "Yes", value: 1 },
  { label: "No", value: 0 },
];

